module.exports = __WEBPACK_EXTERNAL_MODULE_4__;


//////////////////
// WEBPACK FOOTER
// external {"root":"jQuery","amd":"jquery","commonjs":"jquery","commonjs2":"jquery"}
// module id = 4
// module chunks = 0